import { useState, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { categories, articles } from '@/mocks/data';
import ArticleCard from '@/components/base/ArticleCard';
import Breadcrumb from '@/components/base/Breadcrumb';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [searchParams, setSearchParams] = useSearchParams();

  const activeTab = searchParams.get('tab') || slug || 'fashion';
  const currentCategory = categories.find((c) => c.slug === activeTab) || categories[0];
  const categoryArticles = articles.filter((a) => a.category === activeTab);

  const handleTabChange = (newSlug: string) => {
    setSearchParams({ tab: newSlug });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const breadcrumbItems = [
    { label: '首页', href: '/' },
    { label: currentCategory.name },
  ];

  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${currentCategory.name} - 亚欧风格志`,
    description: currentCategory.description,
    url: `https://shenshang003.cn/category/${activeTab}`,
    isPartOf: {
      '@type': 'WebSite',
      name: '亚欧风格志',
      url: 'https://shenshang003.cn',
    },
  };

  return (
    <main className="pt-16">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />

      <div className="bg-background-100">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-10">
          <Breadcrumb items={breadcrumbItems} />
          <h1 className="mt-4 text-3xl md:text-4xl font-heading font-semibold text-foreground-900">
            {currentCategory.name}
          </h1>
          <p className="mt-2 text-foreground-600 max-w-2xl">
            {currentCategory.description}
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-6 py-8">
        <div className="flex items-center gap-2 p-1 bg-background-100 rounded-full w-fit">
          {categories.map((cat) => (
            <button
              key={cat.slug}
              onClick={() => handleTabChange(cat.slug)}
              className={`whitespace-nowrap px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer ${
                activeTab === cat.slug
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-200/70'
              }`}
            >
              {cat.name}
            </button>
          ))}
        </div>
      </div>

      <section className="pb-14 md:pb-20 px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          {categoryArticles.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {categoryArticles.map((article) => (
                <ArticleCard key={article.slug} article={article} variant="featured" />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-background-200">
                <i className="ri-article-line text-2xl text-foreground-400"></i>
              </div>
              <p className="mt-4 text-foreground-500">该分类暂无文章</p>
            </div>
          )}
        </div>
      </section>
    </main>
  );
}